import {isPlatformBrowser} from "@angular/common";
import {inject, Inject, Injectable, Optional, PLATFORM_ID} from '@angular/core';

import {CookieOptions} from "@numizmat/services-models/common";

import {COOKIES_TOKEN} from "./cookie-injection-token";

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  private platformId: Object = inject(PLATFORM_ID);

  constructor(@Optional() @Inject(COOKIES_TOKEN) private cookies?: string) {
  }

  public getCookie(name: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return this.getCookieValue(name, document.cookie);
    } else {
      return this.getCookieValue(name, this.cookies);
    }
  }

  public setCookie(name: string, value: string, options: CookieOptions = {}): void {
    if (isPlatformBrowser(this.platformId)) {
      const {days = 7, path = '/', secure = true, sameSite = 'lax'} = options;
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      let cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${path}`;
      if (secure) {
        cookieString += '; secure';
      }
      cookieString += `; sameSite=${sameSite}`;
      document.cookie = cookieString;
    }
  }

  public deleteCookie(name: string, path: string = '/'): void {
    if (isPlatformBrowser(this.platformId)) {
      this.setCookie(name, '', {days: -1, path});
    }
  }

  private getCookieValue(cookieName: string, cookies: string | undefined): string | null {
    if (!!cookies) {
      const cookiesArray = cookies.split(';');
      for (const cookie of cookiesArray) {
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) {
          return decodeURIComponent(value);
        }
      }
      return null;
    } else {
      return null;
    }
  }
}
